export const displayNumber = (
  x,
  locale = "de-DE",
  options = {
    notation: "standard",
    useGrouping: "auto",
  }
) => {
  return x.toLocaleString(locale, options);
};

export const formatNumber = (number, useDotAsThousandSeperator = false) => {
  return Number(number.replace(/\./g, useDotAsThousandSeperator ? "" : ",").replace(/,/, "."));
};

export const formatAsPercentage = (value, fractionDigits = 2, locale = "de-DE") => {
  return value.toLocaleString(locale, {
    style: "percent",
    minimumFractionDigits: fractionDigits,
  });
};

export const getNumberWith2Decimals = (number) => {
  return Math.round((Number(number) + Number.EPSILON) * 100) / 100;
};
